import { render, staticRenderFns } from "./FiledWithIRS.vue?vue&type=template&id=0cd9a08c&scoped=true&"
import script from "./FiledWithIRS.vue?vue&type=script&lang=js&"
export * from "./FiledWithIRS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9a08c",
  null
  
)

export default component.exports